module.exports = __webpack_public_path__ + "img/MED003.154650ea.png";